import request from '@/utils/request'; // 服务名：ecargopolicy
// 冷链协议保单管理查询

export function protocolColdChain_queryPage(data) {
  return request({
    url: '/ecargoprotocol/tApplicationProtocol/queryPage',
    method: 'post',
    data: data
  });
} //作废

export function protocolInvalid(data) {
  return request({
    url: '/ecargoprotocol/tApplicationProtocol/protocolInvalid',
    method: 'post',
    data: data
  });
} // 冷链补录协议保单查询

export function protocolWarrantyInput_queryPage(data) {
  return request({
    url: '/ecargoprotocol/tApplicationProtocol/queryPageInfo',
    method: 'post',
    data: data
  });
} // 协议保单管理中的查看

export function protocolWarrantyInput_check(data) {
  return request({
    url: '/ecargoprotocol/tApplicationProtocol/check',
    method: 'post',
    data: data
  });
} // 协议保单管理中的提交保单功能 分为新增提交和修改提交

export function protocolWarrantyInput_submit(data) {
  return request({
    url: '/ecargoprotocol/tApplicationProtocol/submit',
    method: 'post',
    data: data
  });
} // 协议保单模块，点击补录协议保单信息回显投保申请单信息

export function protocolWarrantyInput_buLuQuery(data) {
  return request({
    url: '/ecargoprotocol/tApplicationProtocol/query',
    method: 'post',
    data: data
  });
} // 获取协议保单提交成功之后的序号

export function getApplicationProtocolSerialNo(data) {
  return request({
    url: '/ecargoprotocol/tApplicationProtocol/getApplicationProtocolData',
    method: 'post',
    data: data
  });
}